import {
  Component,
  ChangeDetectionStrategy,
  ViewContainerRef,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FieldWrapper, FormlyModule } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";

/**
 * Soft card wrapper for groups of fields — matches landing-page card
 * language (rounded-2xl white surface, subtle shadow, Lexend section
 * title with no hard border).
 *
 * Usage:
 * ```
 * { wrappers: ['section-wrapper'], props: { label: 'Visibility' }, fieldGroup: [...] }
 * ```
 *
 * Pass `sectionClass: 'none'` to skip the card chrome for nested groups.
 */
@Component({
  selector: "app-formly-section-wrapper",
  standalone: true,
  imports: [CommonModule, FormlyModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section [class]="hostClass">
      @if (props.label) {
        <h3 class="font-alternate text-[18px] font-semibold text-black m-0 mb-4">
          {{ props.label | translate }}
        </h3>
      }
      <div class="flex flex-col gap-4">
        <ng-container #fieldComponent></ng-container>
      </div>
    </section>
  `,
})
export class FormSectionWrapperComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef, static: true })
  override fieldComponent!: ViewContainerRef;

  get hostClass(): string {
    const sc = this.props['sectionClass'] as string | undefined;
    if (sc === 'none') return '';
    const card = 'bg-white rounded-2xl px-6 py-5 shadow-[0_1px_2px_rgba(0,0,0,0.04),0_2px_8px_rgba(0,0,0,0.03)] transition-shadow hover:shadow-[0_6px_20px_rgba(0,0,0,0.06)]';
    return `${card} ${sc ?? ''}`.trim();
  }
}
